import { Typography } from '@mui/material';

import { useIntl } from '@klokhuis/core/Intl';
import { CommonStyles } from '@klokhuis/styles/CommonStyles';

import styles from './NoListingsFallback.module.css';

const NoListingsFallback = () => {
  const { T } = useIntl();
  return (
    <div className={styles.root}>
      <Typography className={CommonStyles.padding_bottom_1} variant="h5">
        {T("error_message.couldn't_find_results.heading")}
      </Typography>
      <Typography className={CommonStyles.padding_bottom_1} variant="body2">
        {T("error_message.couldn't_find_results.body")}
      </Typography>
    </div>
  );
};

export default NoListingsFallback;
